'use strict';

var lingojsCore = require('@bookingcom/lingojs-core');

/* This file is auto-generated and should not be edited (see `forms-generate` script in package.json) */
/**
 *
 * Locale | Example output
 * --- | ---
 * `en-gb` | Thu 5 Dec 2019
 * `en-us` | Thu, Dec 5, 2019
 * `es` | jue, 5 dic 2019
 *
 * ---
 *
 * Full CDF list: https://office.booking.com/admintranslate/site/translate.html?lang=all&aid=1&tag=/date_format_new/short_date_with_weekday/name
 */
var form = 'short_date_with_weekday';
lingojsCore.registerDynamicTags(lingojsCore.t('date_format_new', form, 'name'));

module.exports = form;
//# sourceMappingURL=index.js.map
